// --- Marker so we know the file executed ---
console.log('[pharm-collection] loaded');

// Make the parent component available as BOTH:
// - a global factory: window.pharmCollection()
// - an Alpine named component: Alpine.data('pharmCollection', ...)
// This avoids race conditions with alpine:init firing before we attach listeners.
window.pharmCollection = function () {
  return {
    value: '',
    productsPerPage: 10,
    pages: 1,
    page: 1,
    searchEmpty: false,
    showLoadMore: false,

    init() { this.updateLoadMore(); },

    search() {
      const q = (this.value || '').toLowerCase();
      const items = document.querySelectorAll('#pharm-collection .pharm-row');
      let visible = 0;
      items.forEach((el) => {
        const match = !q || el.textContent.toLowerCase().includes(q);
        el.style.display = match ? '' : 'none';
        if (match) visible++;
      });
      this.searchEmpty = visible === 0;
    },

    loadMore() {
      this.page++;
      const max = this.page * this.productsPerPage;
      document.querySelectorAll('#pharm-collection .pharm-row').forEach((el, i) => {
        el.style.display = i < max ? '' : 'none';
      });
      this.updateLoadMore();
    },

    updateLoadMore() {
      this.showLoadMore = this.page < this.pages;
    }
  };
};

document.addEventListener('alpine:init', () => {
  Alpine.data('pharmCollection', window.pharmCollection);
});


// Row component (qty/add-to-cart)
document.addEventListener('alpine:init', () => {
  Alpine.data('pharmRow', (opts) => ({
    id: opts.id,
    available: !!opts.available,
    label: opts.label || 'Add to cart',

    qty: 1,
    busy: false,
    added: false,

    adjust(d) { this.qty = Math.max(1, (this.qty || 1) + d); },

    async submit(evt) {
      if (!this.available) return;
      if (this.busy) return;
      this.busy = true;
      this.added = false;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: this.id, quantity: this.qty }] })
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw (data || new Error('Add failed'));

        this.qty = 1;

        // refresh drawer & bubble (no /cart.js usage)
        try { await window.refreshEnterpriseCartUI(); } catch {}

        this.added = true;
        setTimeout(() => { this.added = false; }, 900);
      } catch (e) {
        console.error('Add to cart failed', e);
        alert(e?.description || 'Could not add to cart.');
      } finally {
        this.busy = false;
      }
    }
  }));
});

// Re-init after Theme Editor swaps
document.addEventListener('shopify:section:load', (e) => {
  if (window.Alpine && e.target) window.Alpine.initTree(e.target);
});

// Re-render header + drawer from /cart (fresh state), then open the drawer
window.refreshEnterpriseCartUI = async function () {
  const HEADER_ID = 'sections--24640027853110__header';
  const DRAWER_ID = 'sections--24640027885878__cart-drawer';

  const headerWrap = document.getElementById('shopify-section-' + HEADER_ID);
  const drawerWrap = document.getElementById('shopify-section-' + DRAWER_ID);
  const bust = Date.now();

  const openDrawer = () => {
    const cd = document.querySelector('cart-drawer');
    if (cd?.open) { cd.open(); return; }
    const toggle =
      document.querySelector('#cart-icon-bubble a, #cart-icon-bubble button') ||
      document.querySelector('[aria-controls="CartDrawer"]') ||
      document.querySelector('[data-cart-trigger]');
    if (toggle) { toggle.click(); return; }
    document.dispatchEvent(new CustomEvent('cart:open'));
    document.dispatchEvent(new CustomEvent('theme:cart:open'));
  };

  // ---- 1) Try MULTI-SECTION JSON (this theme’s likely requirement)
  try {
    const res = await fetch(`/cart?sections=${encodeURIComponent([HEADER_ID, DRAWER_ID].join(','))}&_=${bust}`, {
      headers: { Accept: 'application/json' },
      credentials: 'include'
    });
    if (res.ok) {
      const html = await res.json();

      if (headerWrap && html[HEADER_ID]) {
        headerWrap.innerHTML = html[HEADER_ID];
        if (window.Alpine) window.Alpine.initTree(headerWrap);
        document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId: HEADER_ID, target: headerWrap } }));
      }

      if (drawerWrap && html[DRAWER_ID]) {
        // Directly swap the drawer section’s innerHTML from JSON payload
        drawerWrap.innerHTML = html[DRAWER_ID];

        // Re-init frameworks
        if (window.customElements?.upgrade) {
          drawerWrap.querySelectorAll('*').forEach(el => { try { window.customElements.upgrade(el); } catch {} });
        }
        if (window.Alpine) window.Alpine.initTree(drawerWrap);

        document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId: DRAWER_ID, target: drawerWrap } }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('theme:cart:change'));

        setTimeout(openDrawer, 0);
        return; // ✅ done
      }
    }
  } catch (_) {
    // fall through to HTML fallback
  }

  // ---- 2) Fallback: single section HTML (rarely needed on your theme)
  try {
    if (headerWrap) {
      const res = await fetch(`/cart?section_id=${encodeURIComponent(HEADER_ID)}&_=${bust}`, {
        headers: { Accept: 'text/html' },
        credentials: 'include'
      });
      if (res.ok) {
        const text = await res.text();
        const tmp = document.createElement('div');
        tmp.innerHTML = text.trim();
        const newInner = tmp.querySelector('#shopify-section-' + CSS.escape(HEADER_ID))?.innerHTML || text;
        headerWrap.innerHTML = newInner;
        if (window.Alpine) window.Alpine.initTree(headerWrap);
        document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId: HEADER_ID, target: headerWrap } }));
      }
    }
  } catch (_) {}

  try {
    if (drawerWrap) {
      const res = await fetch(`/cart?section_id=${encodeURIComponent(DRAWER_ID)}&_=${bust}`, {
        headers: { Accept: 'text/html' },
        credentials: 'include'
      });
      if (res.ok) {
        const text = await res.text();
        const tmp = document.createElement('div');
        tmp.innerHTML = text.trim();
        const fresh = tmp.querySelector('#shopify-section-' + CSS.escape(DRAWER_ID));
        if (fresh) {
          drawerWrap.innerHTML = fresh.innerHTML;
          if (window.customElements?.upgrade) {
            drawerWrap.querySelectorAll('*').forEach(el => { try { window.customElements.upgrade(el); } catch {} });
          }
          if (window.Alpine) window.Alpine.initTree(drawerWrap);
          document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId: DRAWER_ID, target: drawerWrap } }));
        }
      }
    }
  } catch (_) {}

  document.dispatchEvent(new CustomEvent('cart:refresh'));
  document.dispatchEvent(new CustomEvent('theme:cart:change'));
  setTimeout(openDrawer, 0);
};




// Optimistic visual bump for the header bubble (#cart-icon-bubble)
window.bumpCartBubble = function (delta) {
  try {
    const wrap = document.querySelector('#cart-icon-bubble');
    if (!wrap) return;

    // badge container (theme’s markup)
    let badge = wrap.querySelector('.header__cart-count');
    if (!badge) {
      badge = document.createElement('div');
      badge.className = 'header__cart-count absolute bg-theme-text text-theme-bg text-center';
      wrap.appendChild(badge);
    }

    // visible number
    let num = badge.querySelector('span[aria-hidden="true"]');
    if (!num) {
      num = document.createElement('span');
      num.setAttribute('aria-hidden', 'true');
      badge.prepend(num);
    }

    const cur = parseInt(num.textContent || '0', 10) || 0;
    const next = Math.max(0, cur + (parseInt(delta, 10) || 0));
    num.textContent = next;

    // accessible text
    let sr = badge.querySelector('.visually-hidden');
    if (!sr) {
      sr = document.createElement('span');
      sr.className = 'visually-hidden';
      badge.appendChild(sr);
    }
    sr.textContent = `Cart, ${next} item${next === 1 ? '' : 's'}`;
  } catch {}
};